import styled from "styled-components";

export const EmployeeScreenContainer = styled.div`
  &&& {
    margin-top: 80px;
    padding-bottom: 32px;
  }
`;
